import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Jsonsmkyu9xjl7fv as Json } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { CodeBlockSemantic_getInstance2upnqm8klgt9a as CodeBlockSemantic_getInstance } from '../components/TempSemantics.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_shown_$ref_kipsub2u3yvjqlogkp3 as TextView$_get_shown_$ref_kipsub,
  TextView$_set_shown_$ref_l7jsq921p8dnwznnah1 as TextView$_set_shown_$ref_l7jsq9,
} from './CsvRenderer.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { textPopover3tarprbgmgxbr as textPopover } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerJson(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(), JsonRenderer_getInstance());
}
function JsonRenderer$json$lambda($this$Json) {
  $this$Json.prettyPrint_1 = true;
  $this$Json.encodeDefaults_1 = true;
  return Unit_instance;
}
function JsonRenderer$cellView$lambda$lambda($this$Json) {
  $this$Json.encodeDefaults_1 = false;
  return Unit_instance;
}
var JsonRendererClass;
function JsonRenderer() {
  if (JsonRendererClass === VOID) {
    class $ {
      constructor() {
        JsonRenderer_instance = this;
        this.name_1 = 'JSON';
        var tmp = this;
        tmp.json_1 = Json(VOID, JsonRenderer$json$lambda);
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_dgaouj_k$(context, module_0) {
        return 0.1;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_dgaouj_k$(context, module_0);
      }
      form_q74x24_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          var errorMessage = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
          var this_0 = themed(element, CodeBlockSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextArea())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = (it) => {
            var tmp;
            try {
              tmp = JsonRenderer_getInstance().json_1.encodeToString_k0apqx_k$(serializer, it);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                tmp_0 = 'Error encoding: ' + e.message;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          };
          var jsonLens = value.lens_u4wb4z_k$(tmp, (original, newJson) => {
            var tmp;
            try {
              errorMessage.set_value_v1vabv_k$(null);
              tmp = JsonRenderer_getInstance().json_1.decodeFromString_jwu9sq_k$(serializer, newJson);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                errorMessage.set_value_v1vabv_k$('Parse error: ' + e.message);
                tmp_0 = original;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          });
          element_0.bind_gesskf_k$(element_0.content_1, jsonLens);
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(errorMessage) == null));
          var tmp_3 = KMutableProperty0();
          var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_1);
          var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_1));
          element_1.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
            var tmp0_elvis_lhs = $this$invoke.invoke_r7m7el_k$(errorMessage);
            return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_q74x24_k$(context, value, module_0);
      }
      view_hsl4in_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_0 = themed(_this__u8e3s4, CodeBlockSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_wraps_9wisy1_k$(true);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp;
            try {
              tmp = JsonRenderer_getInstance().json_1.encodeToString_k0apqx_k$(serializer, $this$invoke.invoke_r7m7el_k$(value));
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                tmp_0 = 'Error: ' + e.message;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          });
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_hsl4in_k$(context, value, module_0);
      }
      cellView_v4jtjx_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var compactJson = Json(VOID, JsonRenderer$cellView$lambda$lambda);
          var tmp = context.serializer_1;
          var serializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_ellipsis_rhzl3b_k$(true);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_2, ($this$invoke) => {
            var tmp;
            try {
              tmp = compactJson.encodeToString_k0apqx_k$(serializer, $this$invoke.invoke_r7m7el_k$(value));
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                tmp_0 = 'Error';
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_v4jtjx_k$(context, value, module_0);
      }
      columnWidth_a9nnq7_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_a9nnq7_k$(context, module_0);
      }
      labeledForm_jdnfre_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          JsonRenderer_getInstance().form_q74x24_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_jdnfre_k$(context, value, module_0, label, description);
      }
      labeledView_rlcwih_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          JsonRenderer_getInstance().view_hsl4in_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_rlcwih_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'JsonRenderer', VOID, VOID, [Renderer()]);
    JsonRendererClass = $;
  }
  return JsonRendererClass;
}
var JsonRenderer_instance;
function JsonRenderer_getInstance() {
  if (JsonRenderer_instance === VOID)
    new (JsonRenderer())();
  return JsonRenderer_instance;
}
//region block: exports
export {
  registerJson as registerJson8qalkxxl4iau,
};
//endregion

//# sourceMappingURL=JsonRenderer.mjs.map
